import { styled } from '@mui/system'
import { fontSizes, colors } from '../consts'
import { Tabs } from '../LazyComponents'

type TabHeaderStyleProps = {
  tabColor: 'light' | 'dark' | 'gray'
  indicolor?: string
  topRadius?: number
  bottomRadius?: number
  noBackground?: boolean
  fullwidth?: boolean
}

export const TabHeaderStyle = styled(Tabs)<TabHeaderStyleProps>(
  ({
    tabColor,
    indicolor,
    topRadius,
    bottomRadius,
    noBackground,
    fullwidth,
    theme,
  }) => ({
    width: fullwidth ? '100%' : 'auto',
    background: noBackground ? 'none' : getTabColor(tabColor, 'background'),
    borderRadius: `${topRadius ? `${topRadius}px ${topRadius}px` : `8px 8px`} ${
      bottomRadius ? `${bottomRadius}px ${bottomRadius}px` : `0 0`
    }`,
    '& .MuiTabs-indicator': {
      background: indicolor ? indicolor : getTabColor(tabColor, 'indicator'),
    },
    '& .MuiTab-textColorPrimary': {
      color: getTabColor(tabColor, 'textColorPrimary'),
      fontWeight: 500,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: getTabColor(tabColor, 'Mui-selected'),
      fontWeight: 'bold',
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
      },
    },
    '& .MuiTab-textColorInherit': {
      color: getTabColor(tabColor, 'textColorInherit'),
      fontWeight: 500,
    },
  })
)

export const LinkTab = styled(Tabs)<TabHeaderStyleProps>(({ tabColor, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1, 2, 2),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1, 0, 1.5),
  },
  '& .lnk': {
    color: getTabColor(tabColor, 'textColorPrimary'),
    fontWeight: 300,
    fontSize: '0.9rem',
    textDecoration: 'none',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
    '& a': {
      color: getTabColor(tabColor, 'textColorPrimary'),
      fontWeight: 300,
      fontSize: '0.9rem',
      textDecoration: 'none',
      textTransform: 'uppercase',
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
  },
}))

const getTabColor = (tabColor: 'dark' | 'light' | 'gray' = 'light', item: string) => {
  switch (item) {
    case 'background':
      return tabColor === 'dark'
        ? colors.black
        : tabColor === 'gray'
        ? colors.gray.gray20
        : colors.lightestGrey
    case 'indicator':
      return tabColor === 'dark'
        ? colors.yellow
        : tabColor === 'gray'
        ? colors.text
        : colors.black
    case 'textColorPrimary':
      return tabColor === 'dark'
        ? colors.gray.gray40
        : tabColor === 'gray'
        ? colors.gray.gray60
        : colors.black
    case 'Mui-selected':
      return tabColor === 'dark'
        ? colors.yellow
        : tabColor === 'gray'
        ? colors.text
        : colors.black
    case 'textColorInherit':
      return tabColor === 'dark' ? colors.yellow : colors.text
    default:
      return colors.gray.gray60
  }
}

type CircularTabsProps = {
  backgroundColor?: string
  uiTheme?: 'dark' | 'light'
}

export const RoundedTabs = styled(Tabs)<CircularTabsProps>(
  ({ theme, uiTheme, backgroundColor }) => ({
    width: '30%',
    background:
      backgroundColor || (uiTheme === 'dark' ? colors.gray.gray80 : colors.offWhite),
    borderRadius: 30,
    zIndex: 20,
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      width: '60%',
    },
    '& .MuiTabs-indicator': {
      background: 'none',
    },
    '&& .MuiTab-textColorPrimary': {
      color: uiTheme === 'dark' ? colors.white : colors.gray.gray60,
      fontWeight: 700,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
    '&& .Mui-selected': {
      color: uiTheme === 'dark' ? colors.white : colors.black,
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  })
)
